import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LawyerItemType } from '../searchAutocomplete.types';
import { AutocompleteItem } from '../AutocompleteItem';
import {
  AutocompleteEntityItem,
  AutocompleteEntityItemLabel,
} from '../entities/EntitiesLib';
import { wantToOpenInNewTab } from '../../../../../utils/linkUtils';
import { Connect } from './AutocompleteLawyerItemContainer';
import { SearchAnimatedLink } from '../animated-link/SearchAnimatedLink';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { getLawyerUrl } from '../autocompleteUtils';
import { ReactComponent as Lawyer } from '../../../../../../../public/img/icons/entities/lawyer.svg';
import { openNewTab } from '../../../../../utils/domUtils';

type Props = {
  item: LawyerItemType;
  label: string;
  selected: boolean;
  showLawyerDecisions: Function;
  onClick: () => void;
  onSecondaryClick: () => void;
  hasOffset: boolean;
};

class RawAutocompleteLawyerItem extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.source = 'autocomplete_result';
  }

  onClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    const { item } = this.props;
    const lawyerPageUrl = buildUrlWithParameters(getLawyerUrl(item), {
      source: this.source,
    });
    this.props.onClick();
    if (wantToOpenInNewTab(event)) {
      openNewTab(lawyerPageUrl);
    } else {
      window.location.href = lawyerPageUrl;
    }
  };

  goToDecisions = (event: React.MouseEvent<HTMLSpanElement>) => {
    const { showLawyerDecisions } = this.props;
    event.stopPropagation();
    if (!wantToOpenInNewTab(event)) {
      event.preventDefault();
      showLawyerDecisions();
    }
    this.props.onSecondaryClick();
  };

  source: string;

  render() {
    const { item, selected, label, hasOffset } = this.props;
    const url = `?q=${label}&lid=${item.metadata.lawyer_id}&source=${this.source}`;
    return (
      <AutocompleteItem
        hasOffset={hasOffset}
        isSelected={selected}
        onClick={this.onClick}
        data-cypress="autocomplete-lawyer-item"
      >
        <AutocompleteEntityItem selected={selected} title={label}>
          <Lawyer className="autocomplete-entity__icon" />
          <AutocompleteEntityItemLabel>{label}</AutocompleteEntityItemLabel>
          <SearchAnimatedLink onClick={this.goToDecisions} href={url}>
            <FormattedMessage id="search/components/search-bar/dropdown/lawyer/AutocompleteLawyerItem.tsx/1" />
          </SearchAnimatedLink>
        </AutocompleteEntityItem>
      </AutocompleteItem>
    );
  }
}

export const AutocompleteLawyerItem = Connect(RawAutocompleteLawyerItem);
